import React, { useState, useMemo, useEffect, useCallback, memo } from "react";
import { useDispatch } from "react-redux";

// Services & Actions
import { apiServices } from "../../../../../../../@core/services/apiReqService";
import { confirmDepositP2P } from "../../../../../../../@core/services/depositService";
import { setStatusSpinner } from "../../../../../../../@core/redux/actions/app/spinner";
import { setDepositData } from "../../../../../../../@core/redux/actions/deposit/index";

// @Utility
import { setStorage } from "../../../../../../../@utility/app/storage";
import alertText from "../../../../../../../@utility/app/alertText";

// Components
import { Grid } from "@material-ui/core";
import Condition from "../../component/Condition";

// CSS
import styles from "./../../../../assets/css/Style.module.css";
import buttonStyles from "./../../../../assets/css/Button.module.css";

const FormDeposit = memo(function FormDeposit({
  channelInfo,
  bankList,
  openBox,
  typePage,
  setPaymentResultState // รับ props ตัวนี้มาจากหน้าแม่ (ถ้ามีการส่งมา)
}) {
  const [money, setMoney] = useState("");

  const dispatch = useDispatch();

  const [popularAmounts, setPopularAmounts] = useState([50, 100, 200, 300, 500, 800, 1000, 2000]);

  // 📍 เพิ่ม State สำหรับจัดการบัญชีแบบ Dynamic
  const [selectBank, setSelectBank] = useState(0);
  const [bankItem, setBankItem] = useState(null);

  useEffect(() => {
    let isMounted = true;

    apiServices({}, "get", "/customer/payment-v3/deposit/popular-p2p")
      .then((data) => {
        const statusCode = data.code;
        if ((statusCode === 200 || statusCode === 0) && isMounted) {
          if (data.result && Array.isArray(data.result) && data.result.length > 0) {
            setPopularAmounts(data.result);
          }
        }
      })
      .catch((error) => {
        console.error("Fetch popular amounts failed:", error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // 📍 เพิ่ม Effect สำหรับคัดกรองเฉพาะบัญชี category === 0
  useEffect(() => {
    if (bankList !== null && Array.isArray(bankList)) {
      const filteredBanks = bankList.filter((item) => item?.category === 0);

      if (filteredBanks.length > 0) {
        setSelectBank(filteredBanks[0].id);
        setBankItem(filteredBanks);
      } else {
        setSelectBank(0);
        setBankItem([]);
      }
    }
  }, [bankList]);

  // const min = channelInfo?.min_balance || 50;

  // const resultAmounts = useMemo(() => {
  //   let result = [min < popularAmounts[0] ? popularAmounts[0] : min];

  //   for (let i = 1; i < popularAmounts.length; i++) {
  //     const base = popularAmounts[i];
  //     const prev = result[i - 1];
  //     let next = Math.max(prev + min, base);

  //     const maxLimit = channelInfo?.max_balance || 20000;
  //     if (next > maxLimit) next = maxLimit;

  //     if (!result.includes(next)) {
  //       result.push(next);
  //     }
  //   }
  //   return result;
  // }, [min, popularAmounts, channelInfo?.max_balance]);

  const showWarning = useCallback((text) => {
    openBox({
      statusShow: true,
      statusAlert: "warning",
      titleAlert: "แจ้งเตือน",
      textAlert: text,
    });
  }, [openBox]);

  const confirmTransaction = useCallback(() => {
    const amount = parseInt(money);
    if (!amount || amount <= 0) {
      return showWarning("กรุณาระบุจำนวนที่ต้องการเติมเงิน !");
    }
    if (amount < channelInfo?.min_balance) {
      return showWarning(`ยอดเติมเงินเริ่มต้นที่ ${channelInfo?.min_balance} บาท`);
    }
    if (channelInfo?.max_balance && amount > channelInfo?.max_balance) {
      return showWarning(`ยอดเติมเงินสูงสุด ${channelInfo?.max_balance} บาท`);
    }

    // 📍 เช็คเพิ่มเติม ป้องกันการกดโดยยังไม่มีบัญชีที่ถูกต้อง
    if (selectBank === 0) {
      return showWarning("ไม่พบบัญชีที่สามารถใช้ทำรายการได้");
    }

    const payload = {
      amount: amount,
      channelId: channelInfo?.id,
      bankId: selectBank, // 📍 แก้ไข: ใช้ selectBank แทน bankList?.[0]?.id
      channel: channelInfo?.key || "p2p",
    };

    // 1. เปิด Spinner ระหว่างส่งคำขอ
    dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังทำรายการ กรุณารอสักครู่" }));

    // 2. เรียกใช้งาน Service (ใช้ Pattern โปรเจกต์เก่า)
    confirmDepositP2P(payload).then((data) => {
      const statusCode = data?.code;

      // ปิด Spinner
      dispatch(setStatusSpinner({ status: false, textProcess: null }));

      if (statusCode === 200 || statusCode === 0) {
        // เซ็ตข้อมูลลง Storage และ Redux เพื่อให้หน้าแม่รับรู้สถานะทันที
        setStorage("processDeposit", data.result?.id);

        if (data?.result?.payment_result) {
          setStorage("paymentResult", JSON.stringify(data.result?.payment_result));
        }

        dispatch(setDepositData(data.result));

        // ถ้าหน้าแม่ส่ง State Setter มาให้ ก็สั่งอัปเดตด้วย
        if (setPaymentResultState) {
          setPaymentResultState(data.result);
        }

      }
      else if (statusCode === 36 || statusCode === 79) {
        if (data?.result?.swift_code) {
          openBox({
            statusShow: true,
            statusAlert: "warning",
            titleAlert: "แจ้งเตือน",
            textAlert: `สร้างรายการไม่สำเร็จ เนื่องจากไม่สามารถเชื่อมต่อกับผู้ให้บริการ (${data?.result?.swift_code}) <div class="alertMessageError">** หมายเหตุ : ${data?.result?.message} **</div>`
          });
        }
        else {
          openBox(alertText(statusCode));
        }
      }
      else {
        // จัดการ Error
        if (statusCode === 2 || statusCode === 4) {
          openBox(alertText(statusCode));
          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        } else {
          openBox(alertText(statusCode));
        }
      }
    }).catch((err) => {
      dispatch(setStatusSpinner({ status: false, textProcess: null }));
      console.error(err);
    });

  }, [money, channelInfo, selectBank, dispatch, showWarning, setPaymentResultState, openBox]); // 📍 เพิ่ม selectBank ลงใน Dependencies

  const renderFixedAmountButtons = () => {
    // 1. เช็คให้ชัวร์ว่าเป็น Array และมีข้อมูล
    if (!Array.isArray(popularAmounts) || popularAmounts.length === 0) return null;

    return popularAmounts.slice(0, 8).map((amount, idx) => {
      const isSelected = Number(money) === amount;
      return (
        <Grid key={idx} item xs={3} md={3} lg={3}>
          <div
            className={["selectTransactionNumber", "center", "crypto-text-body-16-main", isSelected ? "p2pAmountActive" : "crypto-btn-fixed"].join(" ")}
            onClick={() => setMoney(amount)}
          >
            ฿ {amount.toLocaleString()}
          </div>
        </Grid>
      );
    });
  };

  const bankCardUI = useMemo(() => {
    // 📍 แก้ไข: หาธนาคารจาก bankItem ที่มี id ตรงกับ selectBank
    const bank = bankItem?.find((item) => item.id === selectBank);
    if (!bank) return null;

    return (
      <div className={styles.boxMarginFormTop}>
        <div className={styles.boxDetailTop}>
          <div className={[styles.boxAccountAgentTitle, "boxPaddingBottomNone"].join(" ")}>บัญชีที่ต้องใช้โอนเงิน</div>

          <div className={[styles.boxMarginTop, "borderBgLine", "boxPaddingBottom02"].join(" ")}>
            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={2} md={2}>
                <img
                  src={bank.bankimg || bank.bank_img}
                  alt={bank.bankname || bank.bank_name}
                  className="imageSlipSize borderRadius8"
                />
              </Grid>
              <Grid item xs={10} md={10} className="lineHeight24">
                <div className={[styles.boxAccountAgentText, "textBoldHight"].join(" ")}>{bank.bankname || bank.bank_name}</div>
                <div className={styles.boxAccountAgentText}>
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <span>{bank.account || bank.bank_account}</span>
                    </Grid>
                    <Grid item>
                      <span>{bank.name || bank.bank_account_name}</span>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </div>

          <div className={styles.boxMarginTop}>
            <div className="p2pWarningBanner">
              <img
                className="imgDepositProcess"
                src="/images/24-Alert-t.gif"
                alt="เติมเงิน"
              />
              <span className="p2pWarningText">
                ใช้บัญชีนี้ในการโอนเงินเท่านั้น!!
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }, [bankItem, selectBank]); // 📍 เปลี่ยน Dependencies เป็น bankItem และ selectBank

  const renderAmountCard = () => (
    <div className={styles.boxMarginFormTop03}>
      <div className={styles.boxDetailTop}>
        <div className={styles.boxAccountAgentTitle}>
          กรุณาเลือกจำนวนเงิน
        </div>

        {money && (
          <Grid
            className={styles.boxMarginTop02}
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <div className="crypto-text-body-16-main">
                จำนวนเงินที่เลือก :
              </div>
            </Grid>
            <Grid item>
              <div className="cryptoQRAmountText">
                <span className="color-primary">
                  ฿{Number(money).toLocaleString()}
                </span>
              </div>
            </Grid>
          </Grid>
        )}

        <div className="contentBoxMarginTop03 borderBgLine p2pQuickAmounts">
          <Grid container spacing={1}>
            {renderFixedAmountButtons()}
          </Grid>
        </div>

        <div className={[styles.boxMarginFormTop03, "center"].join(" ")}>
          <button
            className={[buttonStyles.btnConfirm, buttonStyles.btnReqBank].join(" ")}
            onClick={confirmTransaction}
            disabled={!money}
            style={{ opacity: !money ? 0.5 : 1, width: "100%" }}
          >
            สร้างรายการฝาก
          </button>
        </div>
      </div>

      <div className={styles.inputBorder02} />

      <div className={styles.boxBankAgentBorder}>
        <Condition typePage={typePage} condition={channelInfo?.condition}></Condition>
      </div>
    </div>
  );

  return (
    <>
      {bankCardUI}
      {/* 📍 เช็คเพิ่มเติมว่ามีธนาคารให้เลือกถึงจะแสดงกล่องจำนวนเงิน */}
      {(bankItem !== null && bankItem.length > 0) && renderAmountCard()}
    </>
  );
});

export default FormDeposit;